module.exports = __webpack_public_path__ + "images/erp-nation-glad-bottom.1788773129009.png";